
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class ContactFormController extends Controller {

	static targets = [ "submitButton" ];

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I handle a request to submit the form through an indirect means (such a keystroke).
	*/
	requestSubmit( event ) {

		event.preventDefault();
		this.element.requestSubmit( this.submitButtonTarget );

	}

}
